import React , { useState, useEffect } from 'react';
// import { API_URL } from '../../utils/config';

function Questions(props) {
  const infos = props.Infos;

  const {locale, productKey, context, dataLayer } = props.VarProp;

  const [idReponse, setIdReponse] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [noMoreQuestions, setnoMoreQuestions] = useState(false);


  const [aReponse, setAReponse] = useState([]);
  const [lastReponse, setLastReponse] = useState([]);
  const [idReponseSelectioned, setidReponseSelectioned] = useState(null);
  const [ReponseSelectioned, setReponseSelectioned] = useState([]);

  const [ProductRef, setProductRef] = useState([]);
  const [aProduct, setAProduct] = useState([]);
  const [lastProductRef, setLastProductRef] = useState([]);

  var domainNameQuestions;
  var domainNameProduct;
  var lang = '&lang=';

  if (context === 'int' || context === 'qual') {
    domainNameQuestions = 'support-decision-tool.bostik.'+ context +'.eurelis.info/sdt/matrix.json?key=';
    domainNameProduct = 'support-decision-tool.bostik.'+ context +'.eurelis.info/sdt/products.json?key=';

  } else if (context === 'prod-test') {
    domainNameQuestions = 'support-decision-tool.bostik.prod.eurelis.info/sdt/matrix.json?key=';
    domainNameProduct = 'support-decision-tool.bostik.prod.eurelis.info/sdt/products.json?key=';

  } else {
    domainNameQuestions = 'back.product-selector.bostik/sdt/matrix.json?key=';
    domainNameProduct = 'back.product-selector.bostik/sdt/products.json?key=';
  }

  if(!locale){
    lang = '';
  }

  const ApiRequestQuestions = 'https://'+ domainNameQuestions + productKey + lang + locale;
  const ApiRequestProduct = 'https://'+ domainNameProduct + productKey + lang + locale + "&format=raw&products=";

  useEffect(() => {

      if (aReponse.length > 0 && ReponseSelectioned.length < aReponse.length){
        SaveInfos();
        PushDataLayer(ReponseSelectioned);
      }

      if(lastReponse !== aReponse){
        GetQuestions();
      }

      if(ProductRef.length > 0 && lastProductRef !== ProductRef){
        GetProduct();
      }



      return () => {
        clearInterval(questions);
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[aReponse,ProductRef]);

  if(questions === null){
    return ''
  }else{
    // console.log("aReponse",aReponse)
  }

  function GetQuestions(){
    //ON RECUPERE LES QUESTIONS
    if(idReponse === undefined){
      setIdReponse('')
    }
    const nextQuestion = idReponse ? '&path='+aReponse : '';
    setLastReponse(aReponse);
    fetch(ApiRequestQuestions+nextQuestion,{
      method: 'GET',
      headers: {
        "Accept-Language": "fr",
      },
    })
    .then((res) => {
      return res.json();
    }).then((data) => {
      if(data.error){
        return ''
      }
      //SI REF PRODUIT EXISTE, ON STOCK LES REFS DANS LA VARIABLE "[PRODUCTREF]"
      const choices = data.choices || []
      const refIds = choices.map(ref => ref.id);
      setProductRef(refIds);
      setLastProductRef(refIds);
      //ON STOCK LES QUESTIONS DANS LA VARIABLE "QUESTIONS"
      const questions = data.question || []
      setQuestions(questions)
      setnoMoreQuestions(questions.length === 0);

    })
    .catch(console.log)
  }

  function GetProduct (){

    fetch(ApiRequestProduct + ProductRef,{
      method: 'GET',
      headers: {
        "Accept-Language": "fr",
      },
    })
    .then((res) => {
      return res.json();
    }).then((data) => {
      const newProducts = Object.values(data)
      setAProduct(newProducts)
    })
    .catch(console.log)
  }

  function SelectionedAnswer(answer){

    setidReponseSelectioned(answer.id);
    setAReponse(aReponse =>([...aReponse, answer.id]))

  }

  function PushDataLayer (oSaveinfo){

    if (dataLayer !== null) {
      dataLayer.push({
        'event':'eventGA',
        'eventCategory': 'SDT',
        'eventAction': aReponse,
        'eventLabel': oSaveinfo.answer_id,
      });
    }

    console.log("aReponse",aReponse)
    console.log("dataLayerAnswer", dataLayer)

  }

  function SelectionedProduct(product){

    if (dataLayer !== null) {
      dataLayer.push({
        'event':'eventGA',
        'eventCategory': 'SDT',
        'eventAction': 'productClick',
        'eventLabel': product.label,
      });
    }
    console.log("dataLayerProduct", dataLayer)
  }

  function DeletedAnswer(answerId){

    if (dataLayer !== null) {
      dataLayer.push({
        'event':'eventGA',
        'eventCategory': 'SDT',
        'eventAction': 'eraseSelection',
        'eventLabel': aReponse,
      });

    }
    console.log("dataLayerErase", dataLayer)

    const answerIndex = aReponse.indexOf(answerId)

    if (answerIndex < 0) {
      return
    }

    const newAResponse = aReponse.slice(0, answerIndex)
    setAReponse(newAResponse)

    const newResponseSelectioned = ReponseSelectioned.slice(0, answerIndex)
    setReponseSelectioned(newResponseSelectioned)

    //setAReponse(aReponse.filter((e)=>(e !== answerId)))
    setProductRef([])
    setAProduct([])
  }

  function SaveInfos(answerId){
    const LabelQuestionSelectioned = questions.label;
    const LabelAnswerSelectioned = questions.answers.find(x => x.id === idReponseSelectioned);
    let oSaveinfo = {
      "question_label" : LabelQuestionSelectioned,
      "answer_id" : LabelAnswerSelectioned.id,
      "answer_label" : LabelAnswerSelectioned.label
    }
    setReponseSelectioned(ReponseSelectioned =>([...ReponseSelectioned, oSaveinfo]))
  }

  return (
    <div className="global-part content-block content-default content-selector">
      <div className="wrapper">
        <div className="breadcrumb-block">
          <div className="title-block">
            <div className="title">{infos.sdt_second_title}</div>
          </div>
          { ReponseSelectioned.length === 0 &&
              <div className="subtitle-block">
                <div className="subtitle">{infos.sdt_intro}</div>
              </div>
          }{
            ReponseSelectioned.length > 0 &&
              <div className="choices-block">
                {ReponseSelectioned.map((selec, a) => {
                  return (
                    <div className='choices-item' key={a} >
                        <div className="question-selec">{selec.question_label}</div>
                        <div className="answer-selec" onClick={() => DeletedAnswer(selec.answer_id)}>{selec.answer_label}</div>
                    </div>
                  )
                })}
              </div>
          }
        </div>
        <div className="questions-block">
          {questions && questions.answers && questions.answers.length > 0 && !noMoreQuestions &&
            <div className="questions-wrapper">
              <div className="questions-header">
                <div className="title-block">
                  <div className="title">{questions.label}</div>
                </div>
                <div className="subtitle-block">
                  <div className="subtitle">{infos.sdt_choose_answer}</div>
                </div>
              </div>
              <div className="questions-reponses">
                {questions.answers.map((answer, a) => {
                  return (
                    <div className='answer' key={a} onClick={() => SelectionedAnswer(answer)}>
                      <div className="title-answer">{answer.label}</div>
                    </div>
                  )
                })}
              </div>
            </div>
          }
          {aProduct && aProduct.length > 0 &&
            <div className="product-block">
              <div className="products-header">
                  <div className="title-block">
                    <div className="title">{infos.sdt_our_solution}</div>
                  </div>
                  <div className="subtitle-block">
                    <div className="subtitle">{infos.sdt_choose_product}</div>
                  </div>
              </div>
              <div className="product-list">
                {aProduct.map((product, p) => {
                  return (
                    <div className='product' key={p}>
                      <a href={product.link} target="_blank" rel="noopener noreferrer">
                        <div className="product-content">
                          <div className="image-product">
                            <img src={product.img} alt={product.label}/>
                          </div>
                          <div className="info-product">
                            <div className="title-product">{product.label}</div>
                            <div className="desc-product">{product.desc}</div>
                            <div className="link-product" onClick={() => SelectionedProduct(product)}>
                                {infos.sdt_more}
                                <span className="link-icon">
                                  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      fill="currentColor"
                                      d="M8.33203 0.666992L7.58003 1.41899L11.6227 5.46699L0.332031 5.46699L0.332031 6.53366L11.6227 6.53366L7.58003 10.5817L8.33203 11.3337L13.6654 6.00033L8.33203 0.666992Z"
                                    />
                                  </svg>
                                </span>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  )})}
              </div>
            </div>
          }
        </div>

      </div>
    </div>
  )

}

export default Questions;